import { render } from "./hostDetails.vue?vue&type=template&id=3aded74a"
import script from "./hostDetails.vue?vue&type=script&lang=js"
export * from "./hostDetails.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__